if (!customElements.get('notification-modal')) {
    class NotificationModal extends HTMLElement {
        constructor() {
            super();
            this.show = this.show.bind(this);
            this.timeoutId = null;
            this.timeout = 6000;
            this.message = null;
        }

        connectedCallback() {
           this.message = this.querySelector('.js-notification-modal-message');
            if (!this.message) return;

           this.initListeners();

           window.removeListeners = this.removeListeners.bind(this);
        }

        disconnectedCallback() {
            this.removeListeners();
        }

        initListeners() {
            window.addEventListener('notification-modal:show', this.show);
        }

        removeListeners() {
            window.removeEventListener('notification-modal:show', this.show);
        }

        show(event) {
            const message = event.detail.message;
            if (!message) return;

            this.classList.add('is-active');
            this.message.textContent = message;

            if (this.timeoutId) { 
                clearTimeout(this.timeoutId);
            }

            this.timeoutId = setTimeout(() => {
                this.classList.remove('is-active');
            }, this.timeout);
        }
    }

    customElements.define('notification-modal', NotificationModal);
}